export const BASE_API_ROUTE = 'https://graph.facebook.com/v2.7';

export const GET_PHOTOS_DEFAULT_LIMIT = 200;
